import { getCurrentInstance, computed } from '@vue/composition-api'
import numberFormat from 'locutus/php/strings/number_format'

export default function useCommonData () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const region = computed(() => store.getters.regions)

    const __enMonthMap = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec'
    }
    const __getDollar = (number, decimal) => {
        const decimalPoint = typeof decimal === 'number' ? decimal : 2
        if (parseFloat(number) < 0) {
            return '-$ ' + numberFormat(Math.abs(number), decimalPoint)
        } else {
            return '$ ' + numberFormat(number, decimalPoint)
        }
    }

    const __toKFormat = (num, decimal) => {
        if (typeof num !== 'number') return num
        const absNum = Math.abs(num)
        if (absNum > 999 && absNum < 1000000) {
            return (num / 1000).toFixed(decimal ?? 1) + 'k'
        } else if (absNum >= 1000000) {
            return (num / 1000000).toFixed(decimal ?? 1) + 'm'
        } else {
            return num.toFixed(2)
        }
    }
    const __toKDollarFormat = (num, decimal) => {
        const absNum = Math.abs(num)
        const sign = parseFloat(num) < 0 ? '-' : ''
        if (absNum > 999 && absNum < 1000000) {
            return `${sign}$${(absNum / 1000).toFixed(decimal ?? 1)}k`
        } else if (absNum >= 1000000) {
            return `${sign}$${(absNum / 1000000).toFixed(decimal ?? 1)}m`
        } else {
            return `${sign}$${absNum.toFixed(2)}`
        }
    }
    const __getOrdinal = (i) => {
        var j = i % 10
        var k = i % 100
        if (j === 1 && k !== 11) {
            return i + 'st'
        }
        if (j === 2 && k !== 12) {
            return i + 'nd'
        }
        if (j === 3 && k !== 13) {
            return i + 'rd'
        }
        return i + 'th'
    }
    const __getRegionNameByKey = (key) => {
        const findRegion = region.value.find(item => item.key === key)
        return findRegion?.name || key
    }
    const __getRegionFullNameByKey = (key) => {
        if (key === 'EU') return 'EU (Ireland)'
        const findRegion = region.value.find(item => item.key === key)
        return findRegion?.fullName || key
    }
    const __getRegionTypeByKey = (key) => {
        if (key === 'EU') return 'AWS Region'
        const findRegion = region.value.find(item => item.key === key)
        return findRegion?.type || 'N/A'
    }
    const __getMonthShortString = (month) => {
        const data = {
            '01': 'Jan',
            '02': 'Feb',
            '03': 'Mar',
            '04': 'Apr',
            '05': 'May',
            '06': 'Jun',
            '07': 'Jul',
            '08': 'Aug',
            '09': 'Sep',
            '10': 'Oct',
            '11': 'Nov',
            '12': 'Dec'
        }
        return data[month]
    }
    const __getMonthString = (num) => {
        switch (num) {
        case 1:
            return 'January'
        case 2:
            return 'February'
        case 3:
            return 'March'
        case 4:
            return 'April'
        case 5:
            return 'May'
        case 6:
            return 'Jun'
        case 7:
            return 'July'
        case 8:
            return 'August'
        case 9:
            return 'September'
        case 10:
            return 'October'
        case 11:
            return 'November'
        case 12:
            return 'December'
        }
    }
    const __getDayString = (value) => {
        const data = {
            '1': 'Mon',
            '2': 'Tue',
            '3': 'Wed',
            '4': 'Thu',
            '5': 'Fri',
            '6': 'Sat',
            '7': 'Sun'
        }
        return data[value]
    }
    return {
        region,
        __enMonthMap,
        __getDollar,
        __toKDollarFormat,
        __toKFormat,
        __getOrdinal,
        __getRegionNameByKey,
        __getRegionFullNameByKey,
        __getRegionTypeByKey,
        __getMonthShortString,
        __getMonthString,
        __getDayString
    }
}
